const Resources = {

    table_headers: [
        // {
        //     name:   '#',
        // },
        {
            name:   'Room',
        },
        {
            name:   'Item',
        },
        {
            name:   'Override',
        },
        {
            name:   'Requires correction',
        },
        {
            name:   'Associate',
        },
        {
            name:   'Score',
        },
        {
            name:   'Corrected',
        },
        {
            name:   'Comment',
        },
    ],

    score_data: [
        {
            id:     1,
            name:   'Pass',
        },
        {
            id:     2,
            name:   'Fail',
        },
        {
            id:     3,
            name:   'N/A',
        }
    ],

    inspect_data:{
        require_correction: false,
        associate_id:       '',
        score:              '',
        corrected:          false,
        comment:            'hola',
    },
    
    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'QC',
            href:   '#',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Inspections',
            href:   '/qc-inspection',
            arrow:  "<span class='slash'>/</span>",
        },
    ],

}

export default Resources;